import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { getFromLocal } from 'src/app/core/services/functions.service';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { GeneralsService } from 'src/app/core/services/generals.service';
import { ModuloMenu } from 'src/app/core/services/menu.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class AdminDashboardComponent implements OnInit {
  current = location.href
  currentModule: ModuloMenu
  constructor(private helpers: HelpersService, private activatedRoute: ActivatedRoute, private generalsService: GeneralsService) {
    this.currentModule = getFromLocal(environment.LOCAL_CURRENT_MODULE)
  }

  ngOnInit(): void {
    const data = this.activatedRoute.snapshot.data
    if (data && data.title) {
      this.helpers.setTitle(data.title);
    }
  }

}

